window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.iframeLoadMode = 1;
